import { render, staticRenderFns } from "./hqStuHealthActivitiesShow.vue?vue&type=template&id=f24ca7f4&scoped=true"
import script from "./hqStuHealthActivitiesShow.vue?vue&type=script&lang=js"
export * from "./hqStuHealthActivitiesShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24ca7f4",
  null
  
)

export default component.exports